function getEnv(key, required = true) {
    const value = process.env[key]
    if (required && !value) {
        throw new Error(`Environment variable ${key} is required but not set.`);
    }
    return value
}

export {
    getEnv
}